module.exports = __webpack_public_path__ + "img/culled.b4620bc4.svg";